import Vue from 'vue'

let instance

export const getInstance = () => instance

export const useStripe = ({
	...options
}) => {
	if (instance) return instance

	instance = new Vue({
		data () {
			return {
			}
		},
		methods: {
			/**
			 * 支払い画面にリダイレクト
			 * @return {Object} error エラーオブジェクト
			 */
			async redirectToCheckout (sessionId) {
				// eslint-disable-next-line
				const stripe = Stripe(options.key)

				const { error } = await stripe.redirectToCheckout({
					sessionId: sessionId
				})

				if (error) {
					// ブラウザまたはネットワークの原因で失敗した場合に、
					// error.messageをユーザに返す
					return error
				}
			}
		}
	})
	return instance
}

export const StripePlugin = {
	install (Vue, options) {
		Vue.prototype.$stripe = useStripe(options)
	}
}
